import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  isInboxHasAi: false,
  inboxAiName: '',
  isAiChatHandover: true,
  aiNests: [],
  uiFlags: {
    isLoading: false,
    isAlreadyFetched: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
